<template>
  <div>
    <div class="mb-1 hidden md:flex">
      <div class="flex-1" v-text="$t('global.name')"></div>
      <div class="flex-1" v-text="$t('global.email')"></div>
      <div class="flex-1" v-text="$t('global.role')" v-if="roles"></div>
      <div class="w-20"></div>
    </div>

    <div
      class="border-grey-lightest mb-6 border-b pb-6 md:mb-1 md:flex md:border-0 md:p-0"
      v-for="(item, idx) in data"
      :key="idx"
    >
      <div class="flex-1">
        <label class="block pr-1">
          <span class="mb-1 block md:hidden" v-text="$t('global.name')"></span>
          <input
            type="text"
            class="form-input w-full"
            :class="{ 'border-brand-500': getError('name', idx) }"
            :name="'invitations[' + idx + '][name]'"
            v-model="item.name"
            required
          />
          <span
            class="text-sm text-brand-500"
            v-if="getError('name', idx)"
            v-text="getError('name', idx)"
          ></span>
        </label>
      </div>
      <div class="flex-1">
        <label class="block pr-1">
          <span class="mt-2 mb-1 block md:hidden" v-text="$t('global.email')"></span>
          <input
            type="email"
            class="form-input w-full"
            :class="{ 'border-brand-500': getError('email', idx) }"
            :name="'invitations[' + idx + '][email]'"
            v-model="item.email"
            required
          />
          <span
            class="text-sm text-brand-500"
            v-if="getError('email', idx)"
            v-text="getError('email', idx)"
          ></span>
        </label>
      </div>
      <div class="flex-1" v-if="roles">
        <div class="block pr-1">
          <label class="mt-2 mb-1 block md:hidden" v-text="$t('global.role')"></label>
          <div class="flex w-full">
            <role-input
              :class="{
                'flex-1': true,
                'rounded-r-none border-r-0': allowStandIn,
              }"
              :required="true"
              :options="roles"
              v-model="item.group_role_id"
            ></role-input>
            <input
              type="hidden"
              :name="'invitations[' + idx + '][metadata][group_role_id]'"
              v-model="item.group_role_id"
            />
            <label
              class="flex items-center rounded-r border-t border-b border-r pl-2 pr-4 text-sm text-gray-600"
              v-if="allowStandIn"
            >
              <input
                type="hidden"
                :name="'invitations[' + idx + '][metadata][as_stand_in]'"
                value="0"
              />
              <input
                type="checkbox"
                :name="'invitations[' + idx + '][metadata][as_stand_in]'"
                value="1"
                class="mr-1"
              />
              {{ $t('global.as_stand_in') }}
            </label>
          </div>
          <span
            class="text-sm text-brand-500"
            v-if="getError('group_role_id', idx)"
            v-text="getError('group_role_id', idx)"
          ></span>
        </div>
      </div>
      <div class="mt-4 flex items-baseline justify-end pt-1 md:mt-0 md:w-20">
        <button
          type="button"
          class="btn"
          @click="removeInvitation(idx)"
          v-if="canRemoveInvitation(idx)"
        >
          <span class="far fa-minus"></span>
        </button>
        <button type="button" class="btn" @click="addInvitation(idx)">
          <span class="far fa-plus"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RoleInput from './RoleInput'
export default {
  components: { RoleInput },
  props: {
    roles: {
      type: [Array, null],
      required: false,
    },
    errors: {
      type: [Object, null],
      required: false,
    },
    allowStandIn: {
      type: Boolean,
      required: false,
      default: false,
    },
    default: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      data: this.default,
    }
  },
  methods: {
    removeInvitation(idx) {
      if (
        (this.data[idx].name !== '' || this.data[idx].email !== '') &&
        !confirm(this.$t('invitation.confirm_deletion'))
      ) {
        return
      }

      this.data.splice(idx, 1)
    },
    addInvitation(idx) {
      this.data.splice(idx + 1, 0, {
        name: '',
        email: '',
        group_role_id: '',
        as_stand_in: 0,
      })
    },
    canRemoveInvitation(idx) {
      return this.data.length > 1
    },
    getError(name, idx) {
      let errors = this.errors['invitations.' + idx + '.' + name]
      if (errors === undefined) {
        return null
      }

      return errors.join(' ')
    },
  },
  mounted() {
    if (this.data.length === 0) {
      this.addInvitation(0)
    }
  },
}
</script>
